import type { FlavorsSelection } from "@jti/fe-common/types";

export const getSelectedPackagesCount = (selectedFlavors: FlavorsSelection): number => {
  return Object.values(selectedFlavors).reduce((acc, flavorCount) => acc + flavorCount, 0);
};
